export const API_KEY = 'AIzaSyBc1fHj2tGSwmVraM39ZXzFjvy_qubMct8';

